/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { notificarErroApi } from "utils/alertaCiencia";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idLeadCorretor?: string;
  idUnidade?: string;
  idEmpreendimento?: string;
  valorAto?: string;
  valorAnualSolicitada?: string;
  porcentagemProSolutoPosChaves?: string;
  numeroParcelasProSolutoPosChaves?: string;
  descontoReais?: string;
  descontoPorcentagem?: string;
  valorProposta?: string;
  valorTabela?: number;
  rendaFamiliar?: string;
  fgts?: string;
  subsidio?: string;
  valorFinanciamento?: string;
  valorPMTUtilizada?: string;
  proSolutoPreChavesReais?: string;
  proSolutoPreChavesPorcentagem?: string;
  proSolutoPosChavesReais?: string;
  proSolutoPosChavesPorcentagem?: string;
  comprometimentoMensalMedio?: string;
  comprometimentoMensalMaximo?: string;
  numeroFicha?: string | null;
  atualizarFluxo?: boolean;
  descontoSolicitadoEnum?: string;
  proSolutoPosChaves?: boolean;
  idOportunidade?: string;
}

export function useGerarFluxo() {
  function toNumber(valor: any) {
    if (typeof valor !== "string") return NaN;

    const valorFormatado = valor.replace(/\./g, "").replace(",", ".");

    return parseFloat(valorFormatado);
  }
  const postData = async (props: Props) => {
    const GERAR_FLUXO = `${backofficeEnviroment}/common/oportunidades-lead/gerar-fluxo/pagamento-detalhado/vivaz/v1`;
    const { data } = await instance.post(GERAR_FLUXO, {
      idLeadCorretor: props.idLeadCorretor,
      idUnidade: props.idUnidade,
      idEmpreendimento: props.idEmpreendimento,
      valorAto: toNumber(props.valorAto),
      valorAnualSolicitada: toNumber(props.valorAnualSolicitada || null),
      porcentagemProSolutoPosChaves: toNumber(
        props.porcentagemProSolutoPosChaves || null
      ),
      numeroParcelasProSolutoPosChaves: toNumber(
        props.numeroParcelasProSolutoPosChaves || null
      ),
      descontoReais: toNumber(props.descontoReais || null),
      descontoPorcentagem: toNumber(props.descontoPorcentagem || null),
      valorProposta: toNumber(props.valorProposta),
      valorTabela: props.valorTabela,
      rendaFamiliar: toNumber(props.rendaFamiliar),
      fgts: toNumber(props.fgts),
      subsidio: toNumber(props.subsidio),
      valorFinanciamento: toNumber(props.valorFinanciamento),
      valorPMTUtilizada: toNumber(props.valorPMTUtilizada),
      proSolutoPreChavesReais: toNumber(props.proSolutoPreChavesReais || null),
      proSolutoPreChavesPorcentagem: toNumber(
        props.proSolutoPreChavesPorcentagem || null
      ),
      proSolutoPosChavesReais: toNumber(props.proSolutoPosChavesReais || null),
      proSolutoPosChavesPorcentagem: toNumber(
        props.proSolutoPosChavesPorcentagem || null
      ),
      comprometimentoMensalMedio: toNumber(props.comprometimentoMensalMedio),
      comprometimentoMensalMaximo: toNumber(props.comprometimentoMensalMaximo),
      numeroFicha: props.numeroFicha,
      atualizarFluxo: props.atualizarFluxo,
      descontoSolicitadoEnum: props.descontoSolicitadoEnum,
      proSolutoPosChaves: props.proSolutoPosChaves,
      idOportunidade: props.idOportunidade,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      // toast.success("Fluxo gerado com sucesso!");
    },
    onError: (error: any) => {
      notificarErroApi("Erro ao gerar fluxo", error);
    },
  });

  return mutation;
}
